import { connect } from "react-redux";
import { selectDisplayMode, setDisplayMode } from "~/store/ducks/user/uistate";
import ModeSwitcher from "./ModeSwitcher";

import { selectShowPresentationMode } from "~/store/ducks/domain/ui/dls";
import { selectShowDisplayModeSwitch } from "~/store/ducks/domain/ui/header";

const mapStateToProps = state => ({
  mode: selectDisplayMode(state),
  showPresentationMode: selectShowPresentationMode(state),
  showDisplayModeSwitch: selectShowDisplayModeSwitch(state)
});

const mapDispatchToProps = dispatch => ({
  onChange: event => {
    dispatch(setDisplayMode(event.target.value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModeSwitcher);
